export default __webpack_public_path__ + "static/media/BAKE-BNB.c140dfce.png";